<template>
  <div class="box-bg container" style="height: 100%">
    <div class="container-main">
      <div class="container-main-header">
        <div class="search-box" style="padding-bottom: 10px">
          <div class="index-top-box">
            <span class="index-top-title">智能控制</span>
          </div>
          <div class="top-opption">
            <el-button type="primary" class @click="addequipment()"
              >+添加联动控制</el-button
            >
            <el-button type="primary" class @click="handleRemind()"
              >+提醒配置</el-button
            >
            <el-button type="primary" class @click="toGongGePage()"
              >返回</el-button
            >
          </div>
        </div>
      </div>
      <div class="equipmentlist box-padding-mide" style="margin-top: 10px">
        <div class="container-content-head">
          <span class="title">控制列表</span>
          <div class="search-list-div">
            <el-input
              placeholder="请输入控制名称"
              v-model="name"
              maxlength="50"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="serchKey"
              ></el-button>
            </el-input>
          </div>
        </div>
        <div class="table-box">
          <el-table
            class="table-style"
            :data="tableData"
            align="center"
            :header-cell-style="{ background: '#F6F6F6' }"
            v-loading="isloading"
          >
            <el-table-column type="expand">
              <template slot-scope="props">
                <div class="hiddendetial">
                  <p class="hiddendetialp">
                    设备名称：{{ props.row.deviceName }}
                  </p>
                  <p class="hiddendetialp">
                    属性名称：{{ props.row.attributeName }}
                  </p>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="控制名称" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.name }}</p>
              </template>
            </el-table-column>
            <el-table-column label="设备名称" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.deviceName }}</p>
              </template>
            </el-table-column>
            <el-table-column label="属性名称" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.attributeName }}</p>
              </template>
            </el-table-column>
            <el-table-column label="控制类型" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.type | kztype }}</p>
              </template>
            </el-table-column>
            <el-table-column label="启用状态" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.isOpen | isOpen }}</p>
              </template>
            </el-table-column>
            <el-table-column label="修改人" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.username }}</p>
              </template>
            </el-table-column>
            <el-table-column label="修改时间" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.updateTime | zhDatetime }}</p>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="180px">
              <template slot-scope="scope">
                <a
                  class="td-opption edit"
                  @click="changestate(scope.row.id)"
                  v-if="scope.row.isOpen == 0"
                  >启用</a
                >
                <a
                  class="td-opption edit"
                  @click="changestate(scope.row.id)"
                  v-if="scope.row.isOpen == 1"
                  >停用</a
                >
                <a
                  class="td-opption edit"
                  @click="operation(scope.row.id, scope.row.type)"
                  >详情</a
                >
                <a class="td-opption del" @click="del(scope.row.id)">删除</a>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            v-show="total > 0"
            background
            layout="prev, pager, next"
            class="pageTap"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pagesize"
            :total="total"
          ></el-pagination>
        </div>
      </div>
      <el-dialog
        title="提醒配置"
        :visible.sync="remindIsDialog"
        width="1300px"
        :before-close="handleClose"
      >
        <el-form
          ref="ruleForm"
          :rules="rules"
          :model="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
        >
          <el-row
            v-for="(item, index) in ruleForm.remindMechanisms"
            :key="index"
          >
            <el-col :span="item.type == 0 ? 8 : 6">
              <el-form-item label="提醒类型：">
                <el-select
                  v-model="item.type"
                  placeholder="请选择提醒类型"
                  clearable
                  style="width: 100%"
                >
                  <el-option label="当日" value="0"></el-option>
                  <el-option label="次日" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="item.type == 0">
              <el-form-item label="间隔分钟：">
                <el-input-number
                  placeholder="请输入间隔分钟"
                  v-model="item.intervalTime"
                  :precision="0"
                  :step="1"
                  :min="1"
                  :max="1440"
                  size="small"
                  style="width: 100%"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="item.type == 1">
              <el-form-item label="间隔天数：">
                <el-input-number
                  placeholder="请输入间隔天数"
                  v-model="item.intervalDay"
                  :precision="0"
                  :step="1"
                  :min="1"
                  :max="14"
                  size="small"
                  style="width: 100%"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="item.type == 1">
              <el-form-item label="提醒时间：">
                <el-time-select
                  v-model="item.remindTime"
                  :picker-options="{
                    start: '00:00',
                    step: '00:05',
                    end: '23:59',
                  }"
                  placeholder="请选择提醒时间"
                  style="width: 100%"
                >
                </el-time-select>
              </el-form-item>
            </el-col>
            <el-col :span="item.type == 0 ? 8 : 6">
              <el-form-item label="推送模式：">
                <el-select
                  v-model="item.pushModeArr"
                  multiple
                  collapse-tags
                  placeholder="请选择推送模式"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in pushModeoptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <span
              style="
                display: block;
                float: right;
                margin-right: -45px;
                margin-top: 10px;
                color: red;
                cursor: pointer;
              "
              @click="handleDelDetail(index)"
              >删除</span
            >
          </el-row>
          <el-form-item>
            <a class="td-opption" @click="handleAddDetail()">+添加模板明细</a>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="handleClose()">取消</el-button>
          <el-button type="primary" @click="handleSave()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import "../../style/common.scss";
import store from "@/store/index";

export default {
  data() {
    return {
      isloading: true,
      currentPage: 1, //初始页
      pagesize: 5, //    每页的数据
      total: 0, //总数
      tableData: [],
      type: "2",
      value: "",
      dateRange: ["", ""],
      name: "",
      ruleForm: {
        remindMechanisms: [
          {
            id: undefined,
            type: "",
            intervalTime: "",
            intervalDay: "",
            remindTime: "",
            pushMode: "",
            pushModeArr: [],
          },
        ],
      },
      rules: {},
      remindIsDialog: false, // 提醒配置是否显示
      pushModeoptions: [
        {
          value: "0",
          label: "邮箱发送",
        },
        {
          value: "1",
          label: "短信发送",
        },
        {
          value: "2",
          label: "APP推送",
        },
        {
          value: "3",
          label: "小程序推送",
        },
        {
          value: "4",
          label: "语音拨号提醒",
        },
      ],
    };
  },
  watch: {
    dateRange() {
      this.serchKey();
    },
  },
  mounted() {
    this.getDeviceList();
  },
  methods: {
    changestate(id) {
      this.openOrCloseLinkageControl(id);
    },
    //启用停用联动控制
    openOrCloseLinkageControl(id) {
      this.$api.device
        .openOrCloseLinkageControl(id)
        .then((res) => {
          if (res.code == 200) {
            this.getDeviceList();
            this.$message({ type: "success", message: res.msg });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((res) => {});
    },
    permissionfun(str) {
      //判断权限
      return this.permission.indexOf(str) > -1;
    },
    filteremojifun(e, name, ruleForm) {
      this.$utils.filteremojifun(this, e, name, ruleForm);
    },
    addequipment() {
      sessionStorage.removeItem("projectEditId");
      this.$router.push({
        name: `Linkagecenter1`,
      });
    },
    del(id) {
      this.$confirm("是否确定删除？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      }).then(() => {
        this.$api.device.deleteLinkageControl(id).then((res) => {
          if (res.code == 200) {
            this.getDeviceList();
            this.$toaster.ok(res.msg);
          }
        });
      });
    },
    serchKey() {
      this.currentPage = 1;
      this.getDeviceList();
    },
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.getDeviceList();
    },
    getDeviceList() {
      this.isloading = true;
      if (this.value == "") {
        this.value = undefined;
      }
      this.$api.device
        .getLinkageControlList(this.name, this.currentPage, this.pagesize)
        .then((res) => {
          if (res.code == 200) {
            if (this.currentPage != 1 && res.data.length == 0) {
              this.currentPage = this.currentPage - 1;
              //this.getDeviceList();
            } else {
              this.total = res.count;
              this.tableData = res.data;
            }
            this.isloading = false;
          }
        });
    },
    operation(id, kztype) {
      sessionStorage.setItem("projectEditId", id);
      sessionStorage.setItem("kztype", kztype);
      this.$router.push({
        name: `Linkagecenter1`,
      });
    },
    // 跳转宫格页面
    toGongGePage() {
      this.$router.push({
        name: `intelligentControl`,
      });
    },
    // 提醒配置
    handleRemind() {
      this.remindIsDialog = true;
      this.ruleForm.remindMechanisms = [];

      // 获取提醒机制
      this.getUserRemindMechanism();
    },
    // 获取提醒机制
    getUserRemindMechanism() {
      this.$api.device.getUserRemindMechanism().then((res) => {
        if (res.code == 200) {
          res.data.forEach((val) => {
            val.type = val.type != undefined ? val.type.toString() : "";
            val.pushModeArr =
              val.pushMode != undefined &&
              val.pushMode != "" &&
              val.pushMode != null
                ? val.pushMode.split(",")
                : [];
          });

          this.ruleForm.remindMechanisms = res.data;
        }
      });
    },
    // 保存
    handleSave() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          let bo = true;
          this.ruleForm.remindMechanisms.forEach((val) => {
            if (val.type === "" || val.pushModeArr.length == 0) {
              bo = false;
              return;
            }

            if (val.type == 0 && val.intervalTime === "") {
              bo = false;
              return;
            }

            if (
              val.type == 1 &&
              (val.intervalDay === "" || val.remindTime === "")
            ) {
              bo = false;
              return;
            }

            val.pushMode = val.pushModeArr.toString();
          });

          if (!bo) {
            this.$toaster.error("请完善提醒机制");
            return;
          }

          this.ruleForm.token = store.state.user.token;
          this.$api.device
            .saveUserRemindMechanism(this.ruleForm)
            .then((res) => {
              if (res.code == 200) {
                this.$toaster.ok(res.msg);
                this.handleClose();
              }
            });
        } else {
          this.$toaster.error("保存失败，请先完善提醒机制信息");
        }
      });
    },
    // 关闭添加编辑弹窗
    handleClose() {
      this.ruleForm = {
        remindMechanisms: [
          {
            id: undefined,
            type: "",
            intervalTime: "",
            intervalDay: "",
            remindTime: "",
            pushMode: "",
            pushModeArr: [],
          },
        ],
      };
      this.$refs["ruleForm"].resetFields();
      this.remindIsDialog = false;
    },
    // 添加明细
    handleAddDetail() {
      this.ruleForm.remindMechanisms.push({
        id: undefined,
        type: "",
        intervalTime: "",
        intervalDay: "",
        remindTime: "",
        pushMode: "",
        pushModeArr: [],
      });
    },
    // 删除明细
    handleDelDetail(index) {
      this.ruleForm.remindMechanisms.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.box-padding {
  padding: 20px;
}

.box-bg {
  background: #fff;
}

.td-opption {
  color: #20a9fd;
  margin-right: 5px;
  margin-left: 5px;
}

.box-padding-mide {
  padding-top: 0;
}

.hiddendetial {
  padding-left: 5%;
}

.hiddendetialp {
  margin-top: 5px;
}

.demo-ruleForm {
  width: 95%;
  margin: -10px 0 0 0;
  padding-top: 10px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
    margin-bottom: 0px !important;
  }
}
</style>